import React, { useState, useContext } from "react";
import { Form, Input, Button, notification } from "antd";
// import { UserOutlined } from "@ant-design/icons";
import { authUserContext } from "../../contexts";
import axios from "axios";

const ChangePass = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const auth = useContext(authUserContext);
  const [form] = Form.useForm();

  console.log("auth", auth);
  const handleSubmit = (value) => {
    setErrorMessage("");
    setIsLoading(true);
    const { REACT_APP_URL_WF_API } = process.env;
    axios({
      url: `${REACT_APP_URL_WF_API}UserChangePwd`,
      method: "POST",
      data: {
        Username: auth.username,
        OldPwd: value.currentPassword,
        NewPwd: value.newPassword,
        ChkNewPwd: value.confirmNewPassword,
      },
    })
      .then(({ data: res }) => {
        if (res.result.value === "P") {
          notification.success({
            message: "บันทึกสำเร็จ",
            description: "คุณได้ทำการเปลี่ยน Password สำเร็จแล้ว",
          });
          form.resetFields();
        } else {
          setErrorMessage(res.result.showText);
        }
        setIsLoading(false);
        console.log("res", res);
      })
      .catch((error) => {
        setErrorMessage(error.message);
        setIsLoading(false);
      });
  };
  return (
    <div>
      <div className="row" style={{ marginTop: "1rem" }}>
        <div className="col-auto">
          <h3 className="font-mont-sb fs-18 c-blue">Change password</h3>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <Form
            onFinish={handleSubmit}
            form={form}
            layout="vertical"
            hideRequiredMark="true"
          >
            <div className="row">
              <div className="col">
                <Form.Item
                  name="currentPassword"
                  label="Current Password"
                  rules={[
                    {
                      required: true,
                      message: "Current password is required",
                    },
                  ]}
                >
                  <Input.Password
                    // suffix={<UserOutlined />}
                    className="font-mont-r"
                    type="text"
                    size="large"
                    placeholder="Enter current password"
                  />
                </Form.Item>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Form.Item
                  name="newPassword"
                  label="New Password"
                  rules={[
                    { required: true, message: "New password is required" },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="Enter new password"
                  />
                </Form.Item>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Form.Item
                  name="confirmNewPassword"
                  label="Confirm New Password"
                  rules={[
                    {
                      required: true,
                      message: "Confirm new password is required",
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="Enter confirm new password"
                  />
                </Form.Item>
              </div>
            </div>
            <div className="row justify-content-md-center">
              <div className="col-auto">
                <p style={{ color: "#ff0028d1" }}>{errorMessage}</p>
              </div>
            </div>
            <div className="row justify-content-md-center">
              <div className="col-auto">
                <Form.Item>
                  <Button
                    loading={isLoading}
                    size="small"
                    className="btn-warning"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0px 30px",
                    }}
                    onClick={() => form.submit()}
                  >
                    Save
                  </Button>
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default ChangePass;
